/* Re-sync nudge 2026-08-13 — kick stalled Shopify GitHub sync */
/* NEW-pre-glued-full-pdp.js
   Vanilla JS for the NEW Pre-Glued Full Lash PDP.
   Gallery, tabs, pack options, price/variant sync.
   Variant selection is now driven by NEW-variant-selector.js which dispatches
   new:variant-selected and new:media-selected events.
   Prices on this PDP are MONEY STRINGS (e.g. "£20"), not cents. */
(function () {
  'use strict';

  /* Parse a money string ("£20", "£19.50") to a Number. */
  function parseMoney(str) {
    var n = parseFloat(String(str || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }
  /* Format a Number to a money string using the symbol from a sample string,
     mirroring Liquid's money_without_trailing_zeros (drops a whole ".00"). */
  function formatMoney(num, sample) {
    var m = String(sample || '£').match(/^[^\d.-]*/);
    var symbol = (m && m[0]) || '£';
    var fixed = num.toFixed(2).replace(/\.00$/, '');
    return symbol + fixed;
  }

  function init(root) {
    /* ── Gallery ─────────────────────────────────────── */
    var gallery = root.querySelector('[data-gallery]');
    if (gallery) {
      var thumbs = gallery.querySelectorAll('[data-thumb-index]');
      var slides = gallery.querySelectorAll('[data-slide-index]');
      var progress = gallery.querySelector('[data-progress]');
      var prev = gallery.querySelector('[data-prev]');
      var next = gallery.querySelector('[data-next]');
      var idx = 0;
      var total = slides.length;

      function show(i) {
        if (total === 0) return;
        idx = ((i % total) + total) % total;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
        if (progress) progress.style.width = ((idx + 1) / total * 100) + '%';
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.dataset.thumbIndex, 10)); }); });
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });

        // Swipe / drag the main image to change slides
        var stage = gallery.querySelector('[data-stage]');
        if (stage && total > 1) {
          var swX = 0, swY = 0, swActive = false, swDone = false, SW_THRESH = 40;
          function swStart(x, y) { swX = x; swY = y; swActive = true; swDone = false; }
          function swMove(x, y) {
            if (!swActive || swDone) return;
            var dx = x - swX, dy = y - swY;
            if (Math.abs(dx) > SW_THRESH && Math.abs(dx) > Math.abs(dy)) {
              swDone = true; swActive = false;
              show(idx + (dx < 0 ? 1 : -1));
            }
          }
          function swEnd() { swActive = false; }
          stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; swStart(t.clientX, t.clientY); }, { passive: true });
          stage.addEventListener('touchmove', function (e) { var t = e.touches[0]; swMove(t.clientX, t.clientY); }, { passive: true });
          stage.addEventListener('touchend', swEnd, { passive: true });
          stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; swStart(e.clientX, e.clientY); });
          stage.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch') return; swMove(e.clientX, e.clientY); });
          window.addEventListener('pointerup', swEnd);
          stage.querySelectorAll('img').forEach(function (im) { im.addEventListener('dragstart', function (e) { e.preventDefault(); }); });
          stage.style.touchAction = 'pan-y';
        }

      /* Gallery switch on new:media-selected from NEW-variant-selector.js. */
      root.addEventListener('new:media-selected', function (e) {
        var mediaId = e.detail && e.detail.mediaId;
        if (!mediaId) return;
        var vThumb = root.querySelector('[data-thumb-index][data-media-id="' + mediaId + '"]');
        if (vThumb) vThumb.click();
      });
    }

    /* ── Variant extras JSON (subscribe, SK, gallery media IDs) ── */
    var variantExtrasEl = root.querySelector('[data-variant-extras]');
    var variantExtras = {};
    if (variantExtrasEl) {
      try { variantExtras = JSON.parse(variantExtrasEl.textContent); } catch (e) {}
    }

    /* ── Element refs ────────────────────────────────── */
    var optionInputs = root.querySelectorAll('input[name="new-pre-glued-full-pdp-pack"]');
    var variantInput = root.querySelector('[data-variant-input]');
    var quantityInput = root.querySelector('[data-quantity-input]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var atcCompare = root.querySelector('[data-atc-compare]');
    var klarnaAmount = root.querySelector('[data-klarna-amount]');
    var klarnaInstallments = parseInt((root.querySelector('[data-section-id]') || root).dataset.klarnaInstallments || '3', 10);

    function parsePrices(str) {
      if (!str) return null;
      try { var o = JSON.parse(str); return (o && typeof o === 'object') ? o : null; } catch (e) { return null; }
    }

    var subPanel = root.querySelector('[data-panel="subscribe"]');
    var sellingPlanInput = root.querySelector('[data-selling-plan-input]');
    var sellingPlanSelect = root.querySelector('[data-selling-plan-select]');
    var subPct = subPanel ? parseFloat(subPanel.dataset.subPct || '0') : 0;
    var subDesc = root.querySelector('[data-sub-desc]');
    var defaultPlanId = subPanel ? subPanel.dataset.defaultPlanId : null;
    var currentSubVariantId = subPanel ? (subPanel.dataset.subVariantId || null) : null;
    var currentSubPrice = subPanel ? (subPanel.dataset.subPrice || null) : null;
    var currentSubPrices = subPanel ? parsePrices(subPanel.dataset.subPrices) : null;
    var currentSubPlanId = defaultPlanId;
    var subscribeTab = root.querySelector('[data-tab="subscribe"]');
    var subThumb = root.querySelector('.new-pre-glued-full-pdp-sub__thumb');

    var starterPanel = root.querySelector('[data-panel="starter"]');
    var starterBundleVariantId = starterPanel ? starterPanel.dataset.bundleVariantId : null;
    var starterBundlePrice = starterPanel ? starterPanel.dataset.bundlePrice : null;
    var starterBundleAvailable = starterPanel ? starterPanel.dataset.bundleAvailable === '1' : false;
    var starterCurrentName = root.querySelector('[data-starter-current-name]');
    var starterCurrentPrice = root.querySelector('[data-starter-current-price]');

    /* ── Initial variant state — seed from variant-extras JSON ─── */
    var defaultVariantValue = variantInput ? variantInput.value : null;
    var selectedVariantId = defaultVariantValue;
    var selectedVariantPrice = null;
    var selectedVariantCompare = '';

    if (defaultVariantValue) {
      var initExtras = variantExtras[String(defaultVariantValue)];
      if (initExtras) {
        selectedVariantPrice = initExtras.price || null;
        selectedVariantCompare = initExtras.compare || '';
        if (initExtras.subVariantId) {
          currentSubVariantId = initExtras.subVariantId;
          if (initExtras.subPrice) currentSubPrice = initExtras.subPrice;
          if (initExtras.subPlanId) currentSubPlanId = initExtras.subPlanId;
          if (initExtras.subPrices) currentSubPrices = initExtras.subPrices;
        }
        if (starterPanel && initExtras.skVariantId) {
          starterBundleVariantId = initExtras.skVariantId;
          if (initExtras.skPrice) starterBundlePrice = initExtras.skPrice;
          starterBundleAvailable = !!initExtras.skAvailable;
        }
      }
    }
    if (!selectedVariantPrice) {
      var firstPack = root.querySelector('input[name="new-pre-glued-full-pdp-pack"][value="1"]');
      selectedVariantPrice = firstPack ? firstPack.dataset.price : (priceCurrent ? priceCurrent.textContent : '£0');
    }

    function currentMode() {
      var activeTab = root.querySelector('[data-tab].is-active');
      return activeTab ? activeTab.dataset.tab : 'full-lash';
    }
    function checkedPack() {
      return root.querySelector('input[name="new-pre-glued-full-pdp-pack"]:checked') ||
             root.querySelector('input[name="new-pre-glued-full-pdp-pack"]');
    }

    function updateKlarna(priceStr) {
      if (!klarnaAmount || !priceStr) return;
      var num = parseMoney(priceStr);
      if (!isNaN(num) && klarnaInstallments > 0) {
        klarnaAmount.textContent = formatMoney(num / klarnaInstallments, priceStr);
      }
    }

    /* Recompute pack-card prices from the selected variant.
       2 Pairs = qty 2, display-only 5% off (cart promo applies the real discount). */
    function updatePackCards() {
      var single = parseMoney(selectedVariantPrice);
      optionInputs.forEach(function (inp) {
        var qty = parseInt(inp.dataset.quantity || '1', 10);
        if (qty === 1) {
          inp.dataset.price = selectedVariantPrice;
          inp.dataset.compare = selectedVariantCompare || '';
        } else {
          var full = single * qty;
          var now = full * 0.95;
          inp.dataset.price = formatMoney(now, selectedVariantPrice);
          inp.dataset.compare = formatMoney(full, selectedVariantPrice);
        }
      });
    }

    function updateStarterRefs(variantTitle) {
      if (starterCurrentPrice) starterCurrentPrice.textContent = selectedVariantPrice;
      if (starterCurrentName) {
        var base = starterCurrentName.dataset.starterBaseName || starterCurrentName.textContent;
        starterCurrentName.textContent = variantTitle ? (base + ' – ' + variantTitle) : base;
      }
      if (subDesc) {
        var b = subDesc.dataset.subBaseName || subDesc.textContent;
        subDesc.textContent = variantTitle ? (b + ' – ' + variantTitle) : b;
      }
    }

    function updateSubscriptionThumb(url) {
      if (!subThumb || !url) return;
      subThumb.src = url;
      subThumb.removeAttribute('srcset');
    }

    /* Full-lash mode: apply a pack-card selection (qty multiple of selected variant). */
    function selectOption(input) {
      if (!input) return;
      var label = input.closest('.new-pre-glued-full-pdp-option');
      root.querySelectorAll('.new-pre-glued-full-pdp-option').forEach(function (l) { l.classList.remove('is-selected'); });
      if (label) label.classList.add('is-selected');

      if (variantInput) variantInput.value = selectedVariantId;
      if (quantityInput) quantityInput.value = input.dataset.quantity || '1';
      if (sellingPlanInput) sellingPlanInput.value = '';

      if (priceCurrent && input.dataset.price) priceCurrent.textContent = input.dataset.price;
      if (atcPrice && input.dataset.price) atcPrice.textContent = input.dataset.price;

      if (priceCompare) {
        if (input.dataset.compare) {
          priceCompare.textContent = input.dataset.compare;
          priceCompare.removeAttribute('hidden');
        } else {
          priceCompare.setAttribute('hidden', '');
        }
      }
      if (atcCompare) {
        if (input.dataset.compare) { atcCompare.textContent = input.dataset.compare; atcCompare.removeAttribute('hidden'); }
        else { atcCompare.setAttribute('hidden', ''); }
      }
      updateKlarna(input.dataset.price);

      // Update loyalty points strip to match the selected pack price.
      // parseMoney returns pounds (e.g. 20 for "£20"); ratio is points-per-pound (5).
      if (input.dataset.price) {
        var loyaltyAmtGBP = parseMoney(input.dataset.price);
        document.querySelectorAll('[data-loyalty-pts]').forEach(function(el) {
          var row = el.closest('[data-loyalty-ratio]');
          var ratio = row ? parseFloat(row.dataset.loyaltyRatio) || 5 : 5;
          el.textContent = Math.round(loyaltyAmtGBP * ratio);
        });
      }
    }

    function restoreLashMode() {
      var checked = checkedPack();
      if (checked) selectOption(checked);
    }

    function setSubscribeAvailable(on) {
      if (!subscribeTab) return;
      subscribeTab.hidden = !on;
      subscribeTab.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (!on && subscribeTab.classList.contains('is-active')) {
        var fullTab = root.querySelector('[data-tab="full-lash"]');
        if (fullTab) fullTab.click();
      }
    }

    function subPriceForPlan(planId) {
      if (currentSubPrices && planId && currentSubPrices[planId]) return currentSubPrices[planId];
      return currentSubPrice;
    }

    function applySubscribeMode(active) {
      if (!sellingPlanInput) return;
      if (active) {
        if (!currentSubVariantId) { restoreLashMode(); return; }
        var planId = (sellingPlanSelect && sellingPlanSelect.value) || currentSubPlanId || defaultPlanId || '';
        if (currentSubPrices && planId && !currentSubPrices[planId]) {
          planId = currentSubPlanId || defaultPlanId || planId;
          if (sellingPlanSelect && planId) sellingPlanSelect.value = planId;
        }
        sellingPlanInput.value = planId;
        if (variantInput) variantInput.value = currentSubVariantId || defaultVariantValue || '';
        if (quantityInput) quantityInput.value = '1';
        var subPriceStr = subPriceForPlan(planId) || currentSubPrice ||
          formatMoney(parseMoney(selectedVariantPrice) * (1 - subPct / 100), selectedVariantPrice);
        if (priceCurrent) priceCurrent.textContent = subPriceStr;
        if (priceCompare) priceCompare.setAttribute('hidden', '');
        if (atcPrice) atcPrice.textContent = subPriceStr;
        if (atcCompare) atcCompare.setAttribute('hidden', '');
        updateKlarna(subPriceStr);
      } else {
        sellingPlanInput.value = '';
        restoreLashMode();
      }
    }

    function applyStarterMode(active) {
      if (!variantInput) return;
      if (active && starterBundleVariantId) {
        variantInput.value = starterBundleVariantId;
        if (quantityInput) quantityInput.value = '1';
        if (sellingPlanInput) sellingPlanInput.value = '';
        if (starterBundlePrice) {
          if (priceCurrent) priceCurrent.textContent = starterBundlePrice;
          if (atcPrice) atcPrice.textContent = starterBundlePrice;
          updateKlarna(starterBundlePrice);
        }
        if (priceCompare) priceCompare.setAttribute('hidden', '');
        if (atcCompare) atcCompare.setAttribute('hidden', '');
      } else if (!active) {
        restoreLashMode();
      }
    }

    /* ── Variant selection — driven by new:variant-selected from NEW-variant-selector.js ── */
    function selectVariant(variantId, extras) {
      if (!extras) return;
      selectedVariantId = variantId;
      selectedVariantPrice = extras.price || selectedVariantPrice;
      selectedVariantCompare = extras.compare || '';

      /* Per-variant starter-kit bundle. */
      if (starterPanel) {
        if (extras.skVariantId) {
          starterBundleVariantId = extras.skVariantId;
          starterPanel.dataset.bundleVariantId = extras.skVariantId;
        }
        if (extras.skPrice) {
          starterBundlePrice = extras.skPrice;
          starterPanel.dataset.bundlePrice = extras.skPrice;
        }
        if (typeof extras.skAvailable !== 'undefined') {
          starterBundleAvailable = !!extras.skAvailable;
        }
      }

      /* Per-variant Subscribe & Save. */
      if (subPanel) {
        if (extras.subVariantId) {
          currentSubVariantId = extras.subVariantId;
          subPanel.dataset.subVariantId = extras.subVariantId;
          if (extras.subPrice) {
            currentSubPrice = extras.subPrice;
            subPanel.dataset.subPrice = extras.subPrice;
          }
          currentSubPrices = (extras.subPrices && typeof extras.subPrices === 'object')
            ? extras.subPrices : null;
          if (extras.subPlanId) currentSubPlanId = extras.subPlanId;
          updateSubscriptionThumb(extras.subImage);
          setSubscribeAvailable(true);
        } else {
          currentSubVariantId = null;
          currentSubPrice = null;
          currentSubPrices = null;
          setSubscribeAvailable(false);
        }
      }

      updatePackCards();
      updateStarterRefs(extras.variantTitle || '');

      var mode = currentMode();
      if (mode === 'subscribe') applySubscribeMode(true);
      else if (mode === 'starter') applyStarterMode(true);
      else restoreLashMode();
    }

    /* Listen to variant selection from the shared selector component. */
    root.addEventListener('new:variant-selected', function (e) {
      var variantId = e.detail && String(e.detail.variantId);
      if (!variantId) return;
      var extras = variantExtras[variantId] || {};
      selectVariant(variantId, extras);
    });

    /* On load, open the gallery on the pre-selected variant's image (e.g. deep-linked ?variant=). */
    (function () {
      if (defaultVariantValue) {
        var initEx = variantExtras[String(defaultVariantValue)];
        if (initEx && initEx.mediaId && gallery) {
          var initThumb = root.querySelector('[data-thumb-index][data-media-id="' + initEx.mediaId + '"]');
          if (initThumb) initThumb.click();
        }
      }
    })();

    /* ── Tabs ────────────────────────────────────────── */
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.dataset.tab;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.dataset.panel === id;
          p.classList.toggle('is-active', on);
          if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
        applySubscribeMode(id === 'subscribe');
        applyStarterMode(id === 'starter');
      });
    });

    if (sellingPlanSelect) {
      sellingPlanSelect.addEventListener('change', function () {
        if (currentMode() === 'subscribe') applySubscribeMode(true);
        else if (sellingPlanInput && sellingPlanInput.value) sellingPlanInput.value = sellingPlanSelect.value;
      });
    }

    /* ── Options (1 Pair / 2 Pairs) ─────────────────── */
    optionInputs.forEach(function (i) { i.addEventListener('change', function () { selectOption(i); }); });

    /* ── Click-anywhere on option label selects radio ── */
    root.querySelectorAll('.new-pre-glued-full-pdp-option').forEach(function (lbl) {
      lbl.addEventListener('click', function () {
        var inp = lbl.querySelector('input[type="radio"]');
        if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });

    /* ── Initial sync ────────────────────────────────── */
    updatePackCards();
    updateStarterRefs('');
    restoreLashMode();

    /* ── Collapsible image-led variant dropdown ───────────────────────────────
       Apply the same collapsed trigger style used on legacy PDPs: a trigger
       button shows the currently selected thumb + label + chevron; the list
       opens on demand and closes after choosing.  Mirrors the bridge logic in
       product-information.liquid but scoped to this template. */
    (function () {
      var vsel = root.querySelector('[data-vsel]');
      if (!vsel) return;

      vsel.classList.add('new-vsel--capped', 'new-vsel--collapsible');

      var CHEV = '<span class="new-vsel__trigger-chevron" aria-hidden="true">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M2.5 5L7 9.5L11.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg></span>';

      var groups = Array.prototype.slice.call(vsel.querySelectorAll('[data-option-group]'));

      function buildTrigger(group) {
        var old = group.querySelector('.new-vsel__trigger');
        if (old) old.remove();
        var selRow = group.querySelector('.new-vsel__row.is-selected');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'new-vsel__trigger';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-haspopup', 'listbox');
        if (selRow) {
          var thumb = selRow.querySelector('.new-vsel__thumb');
          if (thumb) btn.appendChild(thumb.cloneNode(true));
          var val = document.createElement('span');
          val.className = 'new-vsel__trigger-value';
          val.textContent = selRow.dataset.optionValue || '';
          btn.appendChild(val);
        } else {
          var ph = document.createElement('span');
          ph.className = 'new-vsel__trigger-value';
          ph.textContent = 'Select';
          btn.appendChild(ph);
        }
        btn.insertAdjacentHTML('beforeend', CHEV);
        /* Insert between the option label and the list — never above the label. */
        var listEl = group.querySelector('.new-vsel__list');
        if (listEl) group.insertBefore(btn, listEl);
        else group.appendChild(btn);
      }

      function closeGroup(group) {
        group.classList.remove('is-open');
        var btn = group.querySelector('.new-vsel__trigger');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }

      groups.forEach(function (group) {
        buildTrigger(group);
        group.addEventListener('click', function (ev) {
          /* Row click — let NEW-variant-selector.js handle the is-selected update,
             then refresh the trigger and close on the next tick. */
          var rowClick = ev.target.closest ? ev.target.closest('.new-vsel__row') : null;
          if (rowClick && !rowClick.classList.contains('is-unavailable')) {
            setTimeout(function () { buildTrigger(group); closeGroup(group); }, 0);
            return;
          }
          /* Trigger click — toggle the list. */
          var trigClick = ev.target.closest ? ev.target.closest('.new-vsel__trigger') : null;
          if (!trigClick) return;
          var willOpen = !group.classList.contains('is-open');
          groups.forEach(closeGroup);
          if (willOpen) {
            group.classList.add('is-open');
            trigClick.setAttribute('aria-expanded', 'true');
            var list = group.querySelector('.new-vsel__list');
            var sel = group.querySelector('.new-vsel__row.is-selected');
            if (list && sel) {
              var rel = sel.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
              list.scrollTop = Math.max(0, rel - list.clientHeight / 2 + sel.offsetHeight / 2);
            }
          }
        });
      });

      /* Close when clicking outside the selector. */
      document.addEventListener('click', function (ev) {
        if (!vsel.contains(ev.target)) groups.forEach(closeGroup);
      });
    })();
  }

  /* ── Remove the Wishlist Hero heart on this PDP ─────────────────────
     The app INJECTS its heart(s) via JS after load (floating button + an
     in-form button), so CSS display:none doesn't stick — it keeps coming
     back. We delete the nodes and re-delete on any re-injection. */
  var WLH_SEL = '.wishlisthero-floating, [class*="wishlisthero"], [class*="wishlist-hero"], [class*="wlh-"], [id*="wishlisthero"]';
  function killWishlist() {
    try { document.querySelectorAll(WLH_SEL).forEach(function (el) { el.remove(); }); } catch (e) {}
  }
  function watchWishlist() {
    killWishlist();
    var t;
    var obs = new MutationObserver(function (mutations) {
      var hit = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 &&
            ((n.matches && n.matches(WLH_SEL)) || (n.querySelector && n.querySelector(WLH_SEL)));
        });
      });
      if (!hit) return;
      clearTimeout(t);
      t = setTimeout(killWishlist, 50);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    [300, 800, 1500, 3000].forEach(function (ms) { setTimeout(killWishlist, ms); });
  }

  /* Ensure the shared selector script is loaded even when the section/snippet
     include hasn't reached the live theme (liquid file sync can stall while
     assets sync fine). Derive its URL from this script's own src so the CDN
     path and theme version are always right. */
  function ensureVselScript() {
    var vsel = document.querySelector('[data-vsel]');
    if (!vsel || vsel.dataset.vselInit) return;
    if (document.querySelector('script[src*="NEW-variant-selector"]')) return;
    var self = document.querySelector('script[src*="NEW-pre-glued-full-pdp"]');
    if (!self || !self.src) return;
    var s = document.createElement('script');
    s.src = self.src.replace(/NEW-pre-glued-full-pdp\.js[^"']*$/, 'NEW-variant-selector.js');
    document.head.appendChild(s);
  }

  function boot() {
    document.querySelectorAll('.new-pre-glued-full-pdp').forEach(init);
    ensureVselScript();
    watchWishlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ── Klarna OSM price sync loader ─────────────────────────────────────────
   Loads the shared NEW-klarna-sync.js (keeps Klarna instalment messaging in
   step with pack/bundle pickers — FCA accuracy). URL derived from this
   script's own src so it works on any CDN asset version. Idempotent. */
(function () {
  if (window.__nkKlarnaSyncV3 || document.querySelector('script[src*="NEW-klarna-sync"]')) return;
  var self = document.querySelector('script[src*="NEW-pre-glued-full-pdp"]');
  if (!self || !self.src) return;
  var s = document.createElement('script');
  s.src = self.src.replace(/NEW-pre-glued-full-pdp\.js[^"']*$/, 'NEW-klarna-sync.js');
  document.head.appendChild(s);
})();
// sync-nudge: 2026-08-14T07:15Z
